<script>
import { useLinkObject } from '@/pages/Dashboard/composables/LinkObject';
import { useDashboardStore } from '@/stores/dashboard-store';
import { useHarbourStore } from '@/stores/harbour-store';
import { mapState } from 'pinia';

export default {
  name: 'StateRenderer',
  components: {},
  setup() {
    return {
      harbourStore: useHarbourStore(),
      dashboardStore: useDashboardStore(),
    };
  },
  data() {
    return {
      linkObject: null,
    };
  },
  created() {
    this.field = this.params.colDef.field;
    this.linkObject = useLinkObject(this.params.data);
  },
  beforeUnmount() {
    this.linkObject = null;
  },
  computed: {
    linkStatuses() {
      return this.dashboardStore.getLinkStatuses(this.params.data);
    },

    mainStatusClassAndText() {
      let status = this.linkStatuses.main;

      const statusMap = {
        completed: {
          className: 'completion-cell-completed',
          text: `Completed (${this.linkObject.submissions.length})`,
        },
        'completed-emails': {
          className: 'completion-cell-completed',
          text: `Completed`,
        },
        sent: {
          className: 'is-sent',
          text: 'Sent',
        },
        'pending-signed': {
          className: 'completion-cell-pending',
          // like "Pending (1/3)""
          text: `Pending (${this.linkObject.emailRecipientsCompleted.length}/${this.emailRecipientsWithoutReassigned.length})`,
        },
        'pending-unsigned': {
          className: 'completion-cell-pending',
          text: 'Pending (0)',
        },
      };

      return statusMap[status];
    },

    mainStatusClass() {
      return this.mainStatusClassAndText.className;
    },

    mainStatusText() {
      return this.mainStatusClassAndText.text;
    },

    getClass() {
      if (this.linkObject.getCompletionState === 'COMPLETED') return 'completion-cell-completed';
      else return 'completion-cell-pending';
    },
    emailRecipientsWithoutReassigned() {
      return this.linkObject?.emailRecipients?.filter((recipient) => !recipient.reassigned) || 0;
    },
    showSkeleton() {
      return this.dashboardStore.showQuickLinksSkeleton;
    },
  },
  methods: {},
};
</script>

<template>
  <div v-if="showSkeleton" style="width: 300px;">
    <SkeletonRenderer class="skeleton-renderer" />
  </div>

  <div class="state-wrapper" v-else>
    <div class="non-approval-state" :class="getClass">
      <div :class="mainStatusClass">
        {{ mainStatusText }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.approver-info {
  display: flex;
}
.approver-date {
  font-size: 11px;
  color: #999;
}
.approver-row {
  font-size: 13px;
  display: flex;
  flex-direction: column;
  text-align: left;
  justify-content: flex-start;
  padding: 5px;
  margin-bottom: 5px;
  border-bottom: 1px solid #dadada;
}

.approver-name i,
.approver-status i {
  margin-right: 10px;
}
.approver-name {
  font-weight: 600;
  white-space: nowrap;
  margin-right: 5px;
}
.approver-email {
  color: #999;
}
.state-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

.completion-cell-completed,
.completion-cell-pending,
.pending-approval,
.is-sent,
.approved-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 20px;
  min-width: 50px;
  border-radius: 16px;
  padding: 3px 12px;
  font-size: 12px;
  color: #333;
}
.completion-cell-completed {
  background-color: #9ccdcd;
}
.completion-cell-pending {
  background-color: #9fd3f0;
}
.pending-approval {
  background-color: #f2df9d;
  color: #333;
}
.is-sent {
  background-color: #9ab9dc;
}
.approved {
  color: green;
}
.pending {
  color: #ab942f;
}
.non-approval-state {
  display: flex;
  flex-direction: column;
  background-color: transparent;
}
.approved-cell {
  min-width: unset;
  padding: 2px 8px;
  margin-bottom: 5px;
  background-color: #cde6e6;
  font-size: 8px;
  line-height: 18px;
}
.skeleton-renderer {
  width: 300px !important;
}
</style>